module.exports = __webpack_public_path__ + "img/desodorante perfumado.96271724.png";